export const ArrowBackIcon = () => (
  <svg
    width="24"
    height="14"
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.879999 4.91002L4.75 1.00002C4.84296 0.906294 4.95357 0.831899 5.07542 0.78113C5.19728 0.730362 5.32799 0.704224 5.46 0.704224C5.59201 0.704224 5.72272 0.730362 5.84458 0.78113C5.96643 0.831899 6.07704 0.906294 6.17 1.00002C6.35625 1.18738 6.46079 1.44084 6.46079 1.70502C6.46079 1.96921 6.35625 2.22266 6.17 2.41002L2.61 6.00002H23C23.2652 6.00002 23.5196 6.10538 23.7071 6.29292C23.8946 6.48045 24 6.73481 24 7.00002C24 7.26524 23.8946 7.51959 23.7071 7.70713C23.5196 7.89467 23.2652 8.00002 23 8.00002H2.55L6.17 11.61C6.26373 11.703 6.33812 11.8136 6.38889 11.9354C6.43966 12.0573 6.4658 12.188 6.4658 12.32C6.4658 12.452 6.43966 12.5827 6.38889 12.7046C6.33812 12.8265 6.26373 12.9371 6.17 13.03C6.07704 13.1238 5.96643 13.1981 5.84458 13.2489C5.72272 13.2997 5.59201 13.3258 5.46 13.3258C5.32799 13.3258 5.19728 13.2997 5.07542 13.2489C4.95357 13.1981 4.84296 13.1238 4.75 13.03L0.879999 9.15002C0.318197 8.58752 0.00263977 7.82503 0.00263977 7.03002C0.00263977 6.23502 0.318197 5.47252 0.879999 4.91002Z"
      fill="white"
    />
  </svg>
);
